import { customAlphabet } from 'nanoid';
import { ID_PREFIX } from './constants';

export function generateTempFieldId() {
  const alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-';
  const nanoid = customAlphabet(alphabet, 14);
  return ID_PREFIX.concat(nanoid());
}

export function generateHTMLIdFromKeyPath(keyPath, fieldType = 'tx-attr') {
  return [fieldType, ...keyPath].join('-');
}

export function convertDropdownValueToKey(string) {
  return string.split(' ').join('-');
}

export function convertMultipicklistValueToKey(string) {
  return string.split(' ').join('-');
}
